import { Star, ExternalLink } from "lucide-react";
import {
  testimonials,
  GOOGLE_REVIEWS_URL,
  GOOGLE_REVIEWS_COUNT,
  GOOGLE_REVIEWS_AVG,
} from "@/lib/testimonials";

const getInitials = (name) => {
  return name
    .replace(/\./g, "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
};

const Stars = ({ count = 5 }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} size={14} className="fill-[#F5B400] stroke-[#F5B400]" />
    ))}
  </div>
);

export const Testimonials = () => (
  <section id="temoignages" className="py-24 md:py-32 bg-[#FAFAFA] relative" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#FF6B6B]">
            Témoignages
          </span>
          <h2 className="mt-3 font-display text-5xl md:text-7xl leading-none uppercase">
            Il·elles m'ont <br />
            <span className="italic">fait confiance.</span>
          </h2>
        </div>
        <div className="flex items-center gap-4">
          <div className="bg-white border-2 border-black rounded-2xl px-5 py-3 shadow-brutal-sm">
            <div className="flex items-center gap-2">
              <Stars />
              <span className="font-display text-2xl">{GOOGLE_REVIEWS_AVG}</span>
            </div>
            <p className="font-sans text-xs font-bold tracking-widest uppercase mt-1">
              {GOOGLE_REVIEWS_COUNT} avis Google
            </p>
          </div>
        </div>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
        {testimonials.map((t) => (
          <article
            key={t.id}
            data-testid={`testimonial-${t.id}`}
            className="break-inside-avoid mb-6 border-2 border-black rounded-3xl p-6 shadow-brutal hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-brutal-sm transition-all"
            style={{ backgroundColor: t.color }}
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-11 h-11 rounded-full bg-black text-white font-display text-lg flex items-center justify-center border-2 border-black">
                {getInitials(t.name)}
              </div>
              <div className="flex-1">
                <p className="font-sans font-bold text-sm leading-tight">{t.name}</p>
                <Stars count={t.rating} />
              </div>
              <svg viewBox="0 0 24 24" className="w-5 h-5 opacity-50" fill="currentColor" aria-label="Google">
                <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z" />
              </svg>
            </div>
            <p className="font-sans text-sm leading-relaxed text-[#1a1a1a]">{t.text}</p>
          </article>
        ))}
      </div>

      <div className="mt-12 text-center">
        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-google-reviews"
          className="inline-flex items-center gap-2 bg-black text-white rounded-full px-8 py-4 font-sans font-bold hover:-translate-y-1 transition-transform"
        >
          Voir mes {GOOGLE_REVIEWS_COUNT} avis sur Google
          <ExternalLink size={16} />
        </a>
      </div>
    </div>
  </section>
);
